// Import utility functions
import { FormatCurrency } from "global/utilities/ConvertCurrency";



// This component renders the fulfilment breakdown table
const FulfilmentCostBreakdownTable = ({ costBreakdown, headerTitle, showShippingSelector = false, serviceCodes, selectedServiceCode, handleServiceCodeChange, userData, orderItemsFromOrderDetails }) => {


    // Store order items safely
    const orderItems = costBreakdown?.order_items || [];


    
    // Return early if no data exists
    if (!costBreakdown) return null;


    //console.log("orderItemsFromOrderDetails: ", orderItemsFromOrderDetails);
    //console.log("orderItems: ", orderItems);


    return (

        <div className="fulfilment-cost-breakdown">

            {/* Header */}
            <div className="fulfilment-cost-breakdown__header">

                {headerTitle &&

                    <h3 className="fulfilment-cost-breakdown__title">
                        Fulfilment Cost Breakdown
                    </h3>

                }

                <p className="fulfilment-cost-breakdown__subtitle">
                    
                </p>

            </div>

            {/* Table wrapper */}
            <div className="fulfilment-cost-breakdown__table-wrapper">

                <table className="fulfilment-cost-breakdown__table">

                    <thead>

                        <tr>

                            <th style={{textAlign: "left"}}>Product</th>

                            <th>Qty</th>

                            <th>Base</th>

                            <th>Print</th>

                            <th>Tax</th>

                            <th>Total</th>

                        </tr>

                    </thead>

                    <tbody>

                        {orderItems.map((item) => (

                            <tr key={item.order_item_id}>

                                {/* Product info */}
                                <td style={{textAlign: "left"}}>

                                    <div className="fulfilment-cost-breakdown__product">

                                        <strong>
                                            {item.title}
                                        </strong>

                                        {orderItemsFromOrderDetails.find((orderItem) => orderItem.id === item.order_item_id)?.order_item_config?.colourway_code &&
                                        
                                            <p>
                                                Colourway Code: {orderItemsFromOrderDetails.find((orderItem) => orderItem.id === item.order_item_id)?.order_item_config?.colourway_code}
                                            </p>
                                        
                                        }
                                        
                                        <span>
                                            {item.sku}
                                        </span>

                                        <small>
                                            {item.pod_product_sku}
                                        </small>

                                    </div>

                                </td>

                                {/* Quantity */}
                                <td>
                                    {item.quantity}
                                </td>

                                {/* Base cost */}
                                <td>
                                    {FormatCurrency(userData?.currency, item.line_base?.exc_tax)}
                                </td>

                                {/* Print cost */}
                                <td>
                                    {FormatCurrency(userData?.currency, item.line_print?.exc_tax)}
                                </td>

                                {/* Tax */}
                                <td>
                                    {FormatCurrency(userData?.currency, item.line_total?.tax)}
                                </td>

                                {/* Total */}
                                <td className="fulfilment-cost-breakdown__total-cell">

                                    {FormatCurrency(userData?.currency, item.line_total?.inc_tax)}

                                </td>

                            </tr>

                        ))}

                    </tbody>

                </table>

            </div>

            {/* Summary */}
            <div className="fulfilment-cost-breakdown__summary">

                <div className="fulfilment-cost-breakdown__summary-row">

                    <span>
                        Items subtotal
                    </span>

                    <strong>
                        {FormatCurrency(userData?.currency, costBreakdown.items?.exc_tax)}
                    </strong>

                </div>

                <div className="fulfilment-cost-breakdown__summary-row">

                    <span>
                        Shipping 

                        {showShippingSelector &&
                        
                            <select value={selectedServiceCode} onChange={handleServiceCodeChange}>

                                {/* Map through the service codes and create an option for each in the dropdown */}
                                {serviceCodes.map((code) =>

                                    <option key={code.service_code} value={code.service_code}>{code.name} {code.est_delivery} ({FormatCurrency(userData?.currency, code.price_exc_tax)})</option>
                                
                                )}

                            </select>

                        }

                        
                    </span>

                    <strong>
                        {FormatCurrency(userData?.currency, costBreakdown.shipping?.exc_tax)}
                    </strong>

                </div>

                <div className="fulfilment-cost-breakdown__summary-row">

                    <span>
                        Tax
                    </span>

                    <strong>
                        {FormatCurrency(userData?.currency, costBreakdown.total?.tax)}
                    </strong>

                </div>

                <div className="fulfilment-cost-breakdown__summary-row fulfilment-cost-breakdown__summary-row--grand-total">

                    <span>
                        Total fulfilment cost
                    </span>

                    <strong>
                        {FormatCurrency(userData?.currency, costBreakdown.total?.inc_tax)}
                    </strong>

                </div>

            </div>

        </div>

    );

};

export default FulfilmentCostBreakdownTable;